
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"53","height":"74","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke-width":"1.3","fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M51.298 72.4H1.394a.73.73 0 01-.731-.729V1.387a.73.73 0 01.731-.728h49.904c.404 0 .73.325.73.728V71.67a.729.729 0 01-.73.728z","stroke":"#005149"}}),_c('path',{attrs:{"stroke":"#24BA80","d":"M9.952 39.79h32.787V19.139H9.952zm7.104-13.044h18.58m-18.58 5.435h18.58"}})])])
          )
        }
      }
    